export default "__VITE_ASSET__N4qnXI$k__"